import {ComponentType, ReactNode} from 'react';

type ComponentWithOverrideOwnProps<TProps> = {
  override?: ReactNode | ComponentType<TProps>;
  component: ComponentType<TProps> | null;
};

type ComponentWithOverrideProps<
  TProps extends Record<string, unknown> = Record<string, never>,
> = ComponentWithOverrideOwnProps<TProps> & TProps;

export function ComponentWithOverride<
  TProps extends Record<string, unknown> = Record<string, never>,
>({
  override,
  component,
  ...props
}: ComponentWithOverrideProps<TProps>): ReactNode {
  const componentProps = props as unknown as TProps;

  if (!override) {
    if (!component) {
      return null;
    }

    const Component = component;
    return <Component {...componentProps} />;
  }

  if (typeof override === 'function') {
    const OverrideComponent = override;
    return <OverrideComponent {...componentProps} />;
  }

  return override;
}
